import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
import createTransition from 'shared-tokens/utils/createTransition';

import { mainCls as cardCls } from '../../style';

const brTablet = createBreakpoint('s');
const brDesk = createBreakpoint('m');
const brLarge = createBreakpoint('l');

export const mainCls =  `${cardCls}__gal`;

export default {
  [mainCls]: {
    height: 275,
    [brTablet]: {
      height: 'auto !important',
      width: 388,
    },
    [brDesk]: {
      width: 328,
      '& .csaSrpcard__gal__slider__cta__btn': {
        width: 194,
      },
    },
    [brLarge]: {
      width: 388,
    },    
    '&.medium': {
      height: 242,
      [brTablet]: {
        width: 328,
      },
      [brDesk]: {
        width: 305,
        '& .csaSrpcard__gal__slider__cta__btn': {
          width: 169,
        },
      },
      [brLarge]: {
        width: 328,
      },
    },    
    '&.small': {
      height: 222,
      [brTablet]: {
        width: 288,
      },
      [brDesk]: {
        width: 271,
        '& .csaSrpcard__gal__slider__cta__btn': {
          width: 145,
        },
      },
      [brLarge]: {
        width: 288,
      },
    },
    '&.maplist': {
      width: '100% !important',
      // height: '275px !important',
      // '&.medium': {
      //   height: '242px !important',
      // },
      // '&.small': {
      //   height: '222px !important',
      // },
      '& .csaSrpcard__gal__wrap': {
        // paddingTop: '0 !important',
        paddingTop: 'calc(100% * 0.5625)'
        // height: '100% !important',
      },
    },
    '&.mapcard': {
      width: '100% !important',
      height: '180px !important',
      '& .csaSrpcard__gal__wrap': {
        paddingTop: '0 !important',
        height: '100% !important',
        borderRadius: '8px 8px 0 0',
        overflow: 'hidden',
      },
    }
  },
  [`${mainCls}__wrap`]: {
    height: '100%',
    [brTablet]: {
      paddingTop: '75%',
      height: 'auto',
      zIndex: 1,
    },
  },
  [`${mainCls}__cont`]: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    '&:hover': {
      [brTablet]: {
        '& .csaSrpcard__gal__slider__arrows': {
          opacity: 1,
          pointerEvents: 'all',
        },
      },
    },
  },
  [`${mainCls}__slider`]: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    [brTablet]: {
      paddingTop: '75%',
      height: 'auto',
    },
    '& .slick-slider': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backfaceVisibility: 'visible',
      
    },
    '& .slick-list': {
      height: '100%',
      margin: 0,
      display: 'block',
      padding: 0,
      overflow: 'hidden',
      position: 'relative',
      backfaceVisibility: 'visible',
      
    },
    '& .slick-track': {
      height: '100%',
      margin: '0 auto',
      display: 'block',
      position: 'relative',
      backfaceVisibility: 'visible',
      
    },
    '& .slick-slide': {
      float: 'left',
      height: '100%',
      backfaceVisibility: 'visible',
      
      '& > div': {
        height: '100%',
        backfaceVisibility: 'visible',

      },
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center center',
        backfaceVisibility: 'visible',

        '&.err': {
          width: 'auto',
          height: 'auto',
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
        }
      },
    },
    [brTablet]: {
      '&.topRound': {
        '& .slick-list': {
          borderTopLeftRadius: '3px',
        }
      },
      '&.botRound': {
        '& .slick-list': {
          borderBottomLeftRadius: '3px',
        },
      },
    },
  },
  [`${mainCls}__slider__imgcont`]: {
    width: '100%',
    height: '100%',
    [brTablet]: {
      background: '#D7DBDF !important',
    }
  },
  [`${mainCls}__slider__img-contain`]: {
    objectFit: 'contain !important',
  },
  [`${mainCls}__slider__arrows`]: {
    position: 'absolute',
    top: '50%',
    left: 8,
    width: 24,
    height: 24,
    transform: 'translate(0, -50%)',
    transition: createTransition(['background-color', 'opacity']),
    background: 'rgba(255, 255, 255, .6)',
    boxShadow: '2px 2px 10px 1px rgba(105, 118, 132, 0.30)',
    opacity: 0,
    pointerEvents: 'none',
    '&:hover': {
      background: 'rgba(255, 255, 255, 1)',
    },
    '&.right': {
      left: 'auto',
      right: 16,
    },
    '& svg': {
      position: 'absolute',
      top: 5,
      left: 5,
    },
    '&.right': {
      left: 'auto',
      right: 8,
      '& svg': {
        left: 'auto',
        right: 5,
      },
    },
  },
  [`${mainCls}__slider__infos`]: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    height: 24,
    pointerEvents: 'none',
    '&.hidden': {
      opacity: 0,
    },
    transform: 'translateZ(0)',
  },
  [`${mainCls}__slider__medias`]: {
    marginRight: 2,
    height: 24,
    background: 'rgba(26, 31, 36, 0.50)',
  },
  [`${mainCls}__slider__counter`]: {    
    width: 52,
    lineHeight: '24px',
    background: 'rgba(26, 31, 36, 0.50)',
  },
  [`${mainCls}__slider__floorplan`]: {
    position: 'absolute',
    bottom: 8,
    left: 8,
    '&.hidden': {
      opacity: 0,
      pointerEvents: 'none',
    },
    transform: 'translateZ(0)',
  },
  [`${mainCls}__slider__floorplan__btn`]: {
    width: 40,
    height: 40,
    padding: '10px',
    transition: createTransition(['color', 'width']),
    boxShadow: '0 2px 4px 0 #697684',
    '&:hover': {
      color: `${colors.f0.rgba}!important`,  
    },
    '& svg': {
      position: 'absolute',
      top: '50%',
      left: 8,
      transform: 'translate(0, -50%)',
    },
    '&:after': {
      content: '"Ingrandisci"',
      position: 'absolute',
      top: '49%',
      left: 35,
      transform: 'translate(0, -50%)',
      fontWeight: 500,
      fontSize: 16,
      color: colors.f0.rgba, 
      opacity: 0,
      pointerEvents: 'none',
      transition: createTransition(['opacity']),
      transitionDelay: '.2s',
      '& svg': {
        left: 12,
      }
    },
    [brTablet]: {
      width: 32,
      height: 32,
      '& svg': {
        left: 4,        
      },
    },
    '&.expanded': {
      width: 130,
      '&:after': {
        opacity: 1,
      },
    },
    '&.closing': {
      '&:after': {
        transitionDuration: 0,
        transitionDelay: 0,
      },
    },
  },
  [`${mainCls}__slider__floorplan__btn__cnt-svg`]: {
    position: 'absolute',
    left: 6,
  },
  [`${mainCls}__slider__labels`]: {
    position: 'absolute',
    top: 8,
    left: 0,
    opacity: 1,
    transition: createTransition(['opacity']),
    '&.hidden': {
      opacity: 0,
    },
  },
  [`${mainCls}__slider__label`]: {
    paddingTop: 1,
    lineHeight: '19px',
    borderRadius: 4,
    '&.highlight': {
      background: '#058B8F',
    },
  },
  [`${mainCls}__slider__cta`]: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
  },
  [`${mainCls}__slider__cta__btn`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 136,
    fontSize: 15,
    lineHeight: '36px',
    [brTablet]: {
      fontSize: 14,
      lineHeight: '32px',
      '&.phoneCall': {
        display: 'none',
      },
      '&.specificLead': {
        transition: createTransition(['background']),
        background: `${colors.secondary.rgba} !important`,
        '& svg': {
          display: 'none',
        },
        '& span': {
          display: 'none',
        },
        '&:after': {
          content: '"Contatta"',
        },
        '&:hover': {
          background: `${colors.f0.rgba} !important`,
        }
      },
    },
  },
  [`${mainCls}__slider__cta__btn--phone`]: {
    marginRight: 3,
    width: 17,
    height: 17,
    [brDesk]: {
      width: 15,
      height: 15,
    },
  },  
  [`${mainCls}__slider__cta__btn--mail`]: {
    marginRight: 7,
    width: 19,
    height: 19,
    [brDesk]: {
      marginRight: 5,
      width: 17,
      height: 17,
    },
  },
  [`${mainCls}__slider__cta__sep`]: {
    marginTop: 16,
    marginBottom: 16,
    width: 120,
    height:1,
    backgroundSize: '4px 1px',
    backgroundImage: 'linear-gradient(90deg, #96a1b0 66%, rgba(255, 255, 255, 0) 0)',
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 0,
    [brDesk]: {
      marginTop: 12,
      marginBottom: 12,
      width: 90,
    },
  },

  [`${mainCls}__slider__cta__pdpbtn`]: {
    padding: '8px 0 7px 0',
    width: 158,
    textAlign: 'center',
    border: 'solid 1px #96a1b0',
    transition: createTransition(['color', 'border-color']),
    '&:hover': {
      color: `${colors.f0.rgba} !important`,
      borderColor: '#505A65',
    },
    [brDesk]: {
      padding: '6px 0 5px 0',
      width: 134,
      fontSize: '13px',
      borderColor: '#d8dbdf',
    },
  },
  [`${mainCls}__slider__cta__back`]: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: 36,
    right: 16,
    '& svg': {
      marginLeft: 8,
    },
    [brDesk]: {
      fontSize: 12,
      '& svg': {
        marginLeft: 4,
        width: 14,
      },
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  [`${mainCls}__slider__cta__back--txt`]:{
    paddingTop: 2,
    [brDesk]: {
      paddingTop: 0,
    },
  },

  [`${mainCls}__slider__cta__img`]: {
    opacity: .15,
  },
};
